import { DisplayGroup } from '@common/components/forms';
import { SuspenseButton } from '@common/components/utility';
import { useProactivePrescriptionRuleStore } from '@common/stores';
import { ProactivePrescriptionRuleEligibilityRules } from '@common/views/proactivePrescriptions/ProactivePrescriptionEligibilityRules';
import { observer } from 'mobx-react';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';

interface IProactivePrescriptionDetailsHeaderProps {
  onSubmit: () => void;
  onCancel: () => void;
  disableSave?: boolean;
}

export const ProactivePrescriptionDetailsHeader = observer(
  ({
    onCancel,
    onSubmit,
    disableSave = false,
  }: IProactivePrescriptionDetailsHeaderProps) => {
    const { selectedProactivePrescriptionRule } =
      useProactivePrescriptionRuleStore();
    return (
      <>
        <Row>
          <Col md={4}>
            <DisplayGroup
              text="Proactive Prescription Type"
              value={selectedProactivePrescriptionRule?.name}
            />
          </Col>
          <Col md={4}>
            <DisplayGroup
              text="Species"
              value={`${selectedProactivePrescriptionRule?.speciesId === 1 ? 'Canine' : 'Feline'}`}
            />
          </Col>
          <Col md={4}></Col>
        </Row>
        {selectedProactivePrescriptionRule && (
          <Row className="mt-3">
            <Col md={12}>
              <ProactivePrescriptionRuleEligibilityRules
                rule={selectedProactivePrescriptionRule}
              />
            </Col>
          </Row>
        )}
        <div className="float-end mt-3">
          <Button
            className="btn-outline-primary btn btn-secondary me-2"
            onClick={onCancel}
          >
            Cancel
          </Button>
          <SuspenseButton
            variant="primary"
            onClick={onSubmit}
            tag="updateProactivePrescriptionRule"
            disabled={disableSave}
          >
            Save
          </SuspenseButton>
        </div>
      </>
    );
  },
);
